import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-menudown',
  templateUrl: './menudown.component.html',
  styleUrls: ['./menudown.component.css']
})
export class MenudownComponent implements OnInit {

  // isTienda = false;
  // isServicio = false;
  // isEstacionamiento = false;
  // isOferta = false;
  // isEvento = false;
  rutaActual = '';

  constructor(private router: Router) {
    if ( event instanceof NavigationEnd) {
      this.getRoute();
    }
   }

  ngOnInit() {
    this.getRoute();
  }

  public getRoute() {
    console.log('get ruta', this.router.url);
    const rutaSeparada = this.router.url.split('/');

    if ( rutaSeparada[1] === 'eventosel') {
      this.rutaActual = 'eventos';
    } else {
      this.rutaActual = rutaSeparada.length > 3 && rutaSeparada[2] !== 'tienda' ? '' : rutaSeparada[1];
    }
  }

}
